import React, { FC } from 'react';

import { Flex, Text } from '@adsk/alloy-react-box';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip';

import { useTranslation } from '../i18n';

const MissingEntities: FC<{ count: number }> = ({ count }) => {
  const { t } = useTranslation();
  return (
    <Flex alignItems="center" justifyContent="center" padding="24px">
      <Tooltip content={t('MISSING_ENTITIES_TOOLTIP', { count })}>
        <Flex alignItems="center" justifyContent="center">
          <AlertWarningIcon
            style={{
              color: theme.colors.charcoal700,
            }}
          />
          <Text typography="bodySmall" color="charcoal700" marginLeft="9px">
            {t('MISSING_ENTITIES_MESSAGE', { count })}
          </Text>
        </Flex>
      </Tooltip>
    </Flex>
  );
};

export default MissingEntities;
